import React, { useContext, useState } from "react";
import { AppContext } from "../../../context/AppContext";
import { ReactComponent as PORTFOLIO_IMG } from "../../../assets/images/Frame (13).svg";
import CloseButtonModal from "../CloseButtonModal";
import Modal from "../Modal";
import CoinCenterContent from "./CoinCenterContent";
import NavigationCashier from "./NavigationCashier";
import { StyledCashierModal } from "./styles";

const CashierModal = ({ button = "Get Coins", variant = "default" }) => {
  const { selectedOptionCashier, updateCashierOption, isTabletScreen } =
    useContext(AppContext);

  const [isOpen, setIsOpen] = useState(false);

  const buttonLabel =
    button === "Cashier" || button === "Buy Crypto" ? "Get Coins" : button;

  const handleOpenModal = () => {
    updateCashierOption("Get Coins");
    setIsOpen(true);
  };

  const renderTrigger = () => {
    if (variant === "sidebar") {
      return (
        <button
          type="button"
          onClick={handleOpenModal}
          style={{
            width: "100%",
            height: "40px",
            border: "none",
            borderRadius: "8px",
            background: "#FFE81A",
            boxShadow: "0px 0px 10px 0px rgba(255, 176, 25, 0.40)",
            color: "#141722",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "800",
            letterSpacing: "0.5px",
            textTransform: "uppercase",
          }}
        >
          {buttonLabel}
        </button>
      );
    }

    if (isTabletScreen) {
      return (
        <button className="button" onClick={handleOpenModal}>
          <PORTFOLIO_IMG />
        </button>
      );
    }

    return (
      <div
        onClick={handleOpenModal}
        style={{
          display: "inline-flex",
          padding: "10px 16px",
          alignItems: "flex-start",
          gap: "10px",
          borderRadius: "8px",
          background: "#FFE81A",
          boxShadow: "0px 0px 10px 0px rgba(255, 176, 25, 0.40)",
          cursor: "pointer",
        }}
      >
        <p
          style={{
            color: "#141722",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "16.8px",
            letterSpacing: "0.5px",
            textTransform: "uppercase",
          }}
        >
          {buttonLabel}
        </p>
      </div>
    );
  };

  return (
    <>
      {renderTrigger()}

      <Modal maxWidth={805} isOpen={isOpen} onClose={setIsOpen}>
        <CloseButtonModal onClick={() => setIsOpen(false)} />
        <StyledCashierModal>
          <NavigationCashier />
          <CoinCenterContent option={selectedOptionCashier} />
        </StyledCashierModal>
      </Modal>
    </>
  );
};

export default CashierModal;
